import React, { useState, useEffect } from 'react';
import { Heart, Star, Calendar, MapPin } from 'lucide-react';
import Loader from './Loader';
import { optimizeImageUrl } from '@/lib/imageUtils';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const TravelStories = () => {
  const [travelStories, setTravelStories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/travel-stories`)
      .then(res => res.json())
      .then(data => {
        setTravelStories(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching travel stories:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <section id="testimonials" className="travel-stories-section">
        <div className="section-header">
          <Heart className="section-icon" />
          <h2 className="section-title">Travel Stories from Our Customers</h2>
          <p className="section-subtitle">Real experiences from families who traveled with us</p>
        </div>
        <Loader />
      </section>
    );
  }

  return (
    <section id="testimonials" className="travel-stories-section">
      <div className="section-header">
        <Heart className="section-icon" />
        <h2 className="section-title">Travel Stories from Our Customers</h2>
        <p className="section-subtitle">Real experiences from families who traveled with us</p>
      </div>

      <div className="stories-grid">
        {travelStories.map((story) => (
          <div key={story.id} className="story-card">
            <div className="story-image-wrapper">
              <img
                src={optimizeImageUrl(story.image, 400)}
                alt={story.name}
                className="story-image"
                loading="lazy"
                decoding="async"
              />
              <div className="story-overlay"></div>
            </div>

            <div className="story-content">
              <div className="story-header">
                <div className="story-author">
                  <h4>{story.name}</h4>
                  <div className="story-meta">
                    <MapPin size={14} />
                    <span>{story.destination}</span>
                  </div>
                </div>
                <div className="story-rating">
                  {[...Array(story.rating)].map((_, i) => (
                    <Star key={i} size={16} fill="#F59E0B" stroke="#F59E0B" />
                  ))}
                </div>
              </div>

              <p className="story-text">{story.story}</p>

              <div className="story-footer">
                <div className="story-package">
                  <Calendar size={14} />
                  <span>{story.package}</span>
                </div>
                <div className="story-date">{story.date}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TravelStories;
